import { render, staticRenderFns } from "./ModalAlertRemoteArea.vue?vue&type=template&id=455bae05"
import script from "./ModalAlertRemoteArea.vue?vue&type=script&lang=js"
export * from "./ModalAlertRemoteArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports